export enum externalFormProtectTypes {
    hide = "hide",
    gray = "gray",
}
